<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div class="wf-p-4" :class="elementClasses(classes('classes'), classes('customClasses'))" :style="elementStyles(styles('styles'))">  
      <div class="wf-flex wf-flex-wrap wf-w-full">
        <div class="wf-w-12 wf-px-2" v-show="content.hasIcon">
          <div
            class="wf-flex wf-justify-center wf-items-center"
            :style="elementStyles(styles('iconContainerStyles'))"
            :class="elementClasses(classes('iconContainerClasses'))"
          >
            <i :style="elementStyles(styles('iconStyles'))" :class="[content.class, content.icon]"></i>  
          </div>
        </div>
        <div class="wf-flex-1 wf-px-2">
          <div class="wf-mb-2" v-show="content.hasTitle">
            <WysiwygEditor
              :styles="{bold: true, size: 'xs'}"
              :showProperties="['color', 'bold', 'size', 'alignment']"
              :value="content.titleText"
              @input="updateContentProperty('titleText', $event)"
            />
          </div>
          <div>
            <WysiwygEditor
              :styles="{size: 'xs', color: '#718096'}"
              :showProperties="['color', 'bold', 'size', 'alignment']"
              :value="content.text"
              @input="updateContentProperty('text', $event)"
            />
          </div>
        </div>
        <div class="wf-w-8 wf-px-2" v-show="content.isClosable">
          <span class="wf-text-lg wf-text-gray-500">&times;</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import WysiwygEditor from './WysiwygEditor'
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({
    components: {WysiwygEditor},
  })
</script>